export const CASE_STUDY_CONSTANT = {
    // テーブル名
    TABLE: 'case_study',
  };
  